$(document).ready(function(){

  // Quote silde
  $('.quoteSlide').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0851/4191/3943/files/Preview.png?v=1724159751'/></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0851/4191/3943/files/Next.png?v=1724159750'/></button>"
  });
  // Quote silde

  // Video controller code
  // $('.videoWrap .videoMain').hide();
  $('.videoController').click(function(){ 
    $(this).parent('.video_poster').hide();
    $(this).parents('.videoWrap').find('.videoMain').show();
    // let videoState = $('.videoMain video')[0];
    // if(videoState.paused){
    //   videoState.play();
    // }else{
    //   videoState.pause();
    // }
    $('.videoMain video')[0].play();
  });
  $('.videoMain video').on('ended',function(){
    // alert('video ended');
    $(this).parents('.videoWrap').find('.video_poster').show();
    $(this).parent('.videoMain').hide();
  });
  // Video controller code

  // Product details page Tab
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  // Product details page Tab

  // Related product silde
  setTimeout(function () {
    $('.cust_relatedSlide').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 361,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }, 4500);
  // Related product silde

  // Service page gallery wrap
  if ($(window).width() > 749) {
    $(".item_1, .item_2").wrapAll('<div class="parent_1"></div>');
    $(".item_3, .item_4, .item_5, .item_6").wrapAll('<div class="parent_2"></div>');
    $(".parent_2 .item_3, .parent_2 .item_4, .parent_2 .item_5").wrapAll('<div class="parent_2_inner"></div>');
    $(".parent_2_inner .item_3, .parent_2_inner .item_4").wrapAll('<div class="parent_2_grandInner"></div>');
  } else {
    $(".item_1, .item_2").wrapAll('<div class="parent_1"></div>');
    $(".item_3, .item_5").wrapAll('<div class="parent_2"></div>');
    $(".item_4").wrapAll('<div class="parent_3"></div>');
    $(".item_6").wrapAll('<div class="parent_4"></div>');
  }
  // Service page gallery wrap

  // Brand logo slider
  if ($(window).width() < 990) {
    $('.index7Slide').slick({
      infinite: true,
      dots: false,
      arrows: false,
      variableWidth: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      pauseOnHover: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            variableWidth: true,
            speed: 4000,
          }
        },
        {
          breakpoint: 361,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          }
        }
      ]
    });
  }
  // Brand logo slider

  // Team member slider
  if ($(window).width() < 990) {
    $('.team_memberSlide').slick({
      dots: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  // Team member slider
  
})